export const webViewLoaderStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
};
export const loaderStyle = { justifyContent: 'center' };
